<template>
    <div class="pt-2">
        <span v-html="text" />
    </div>
</template>
<script>
export default {
    name: 'iatIntro',
    props: {
        text: String
    }
}
</script>